import Checkbox from '../forms/Checkbox';
import React, { Component } from 'react';
import { get, isObject } from 'lodash';
import Column from './Column';

class SelectRow extends Component {
    _toggleSelect = () => this.props.onSelect(this.props.item.id, this.props.item);
    _open = e => {
        if (isObject(e.target.className)) {
            return null;
        }
        return this.props.allowOpen && this.props.onOpen(this.props.item);
    };
    render() {
        const blocked = !(this.props.enableRowFunction && this.props.enableRowFunction(this.props.item));
        const selectBlocked = !(this.props.enableSelectFunction && this.props.enableSelectFunction(this.props.item));

        return (
            <tr
                className={`ckp-tables-body-row ${blocked ? 'is-blocked' : ''} ${
                    this.props.allowOpen && !blocked ? 'is-clickable' : ''
                }`}
            >
                {this.props.selectable ? (
                    <td className="ckp-tables-select-column">
                        {blocked || selectBlocked ? null : (
                            <Checkbox
                                checked={this.props.selected}
                                name={this.props.item.id}
                                onChange={this._toggleSelect}
                            />
                        )}
                    </td>
                ) : null}
                <td className="ckp-tables-rest-column" onClick={this._open}>
                    {this.props.fields.map(f => (
                        <Column
                            key={f.key}
                            isSmall={this.props.smallColumns.includes(f.key)}
                            isLarge={this.props.largeColumns.includes(f.key)}
                            parentItem={this.props.item}
                            value={get(this.props.item, f.key)}
                            transformFunction={this.props.transformFunctions[f.key]}
                        />
                    ))}
                </td>
            </tr>
        );
    }
}

SelectRow.defaultProps = { transformFunctions: {}, smallColumns: [], largeColumns: [], allowOpen: true };

export default SelectRow;
